var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-230 -953.636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150,289.636a8,8,0,1,1-8-8,8,8,0,0,1,8,8",
    transform: "translate(96 672)",
    fill: "#18c99d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.594,295.881h-2.841V294.7a3.7,3.7,0,0,1-2.554-2.29l-.318-.833,2.074-1.193c-.1-.067-.208-.141-.318-.223a2.955,2.955,0,0,1-1.137-2.445,3.125,3.125,0,0,1,.974-2.33,3.526,3.526,0,0,1,1.279-.772v-1.224h2.841v1.259a3.566,3.566,0,0,1,2.06,1.973l.382.859L144.1,288.6a3.473,3.473,0,0,1,.732.5,2.94,2.94,0,0,1,1.038,2.427,3.262,3.262,0,0,1-2.274,3.1Z",
    transform: "translate(96 672)",
    fill: "#119474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.549,293.808v1.028H141.8v-1.017a2.8,2.8,0,0,1-2.623-1.779l1.144-.659a1.681,1.681,0,0,0,1.479,1.133v-2.4a5.452,5.452,0,0,1-1.537-.785,1.916,1.916,0,0,1-.717-1.607,2.063,2.063,0,0,1,.648-1.571,2.62,2.62,0,0,1,1.606-.693v-1.017h.751v1.028a2.577,2.577,0,0,1,2.149,1.583l-1.121.647a1.393,1.393,0,0,0-1.028-.913v2.288c.242.093.427.162.554.22a3.756,3.756,0,0,1,1.005.566,1.934,1.934,0,0,1,.717,1.606,2.354,2.354,0,0,1-2.276,2.346m-.751-5.038v-2.011a.978.978,0,0,0-.924.959c0,.474.265.74.924,1.052m.751,3.732a1.049,1.049,0,0,0,.948-1.028c0-.509-.3-.786-.948-1.075Z",
    transform: "translate(96 672)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollar);
export default __webpack_public_path__ + "static/media/icon-dollar.2755045fa7dc35d32e25516193363bd6.svg";
export { ForwardRef as ReactComponent };